module.exports = __webpack_public_path__ + "img/email.b0d41c28.svg";